<template>
  <div class="Gsbgbox">
    <GSBG />
  </div>
</template>
<script>
import GSBG from "@/components/GSBG.vue";
export default {
  components: { GSBG },
  data() {
    return {};
  },

  methods: {},
};
</script>
<style lang="scss" scoped>
.Gsbgbox {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  background-color: #efefef;
  overflow-y: scroll;
}
</style>